import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { INK } from "../../theme/tokens";
import { type SwitcherRow, switcherRowLabel } from "../../utils/facilityDepartments";

type Props = {
	row: SwitcherRow;
	/** Bold: the chosen department's row, or its facility's row while that facility is collapsed. */
	isEmphasized: boolean;
};

/** One department-switcher row: a facility with its expand chevron, or a department, indented under its facility when it has one. */
export const SwitcherRowLabel: FC<Props> = ({ row, isEmphasized }) => {
	const isFacilityRow = row.kind === "facility";
	const isExpanded = isFacilityRow && row.isExpanded;
	const ExpandIcon = isExpanded ? ExpandMoreIcon : ChevronRightIcon;
	const { t } = useTranslation();
	const label = switcherRowLabel(row, t("header.facilitySwitcher.mainDepartment"));
	return (
		// The indent is the chevron's width plus the gap, so a department's name lines up under its facility's.
		<Box sx={{ display: "flex", alignItems: "center", gap: 0.5, minWidth: 0, paddingInlineStart: row.kind === "department" && row.isInsideFacility ? 3 : 0 }}>
			{isFacilityRow && (
				<ExpandIcon
					fontSize="small"
					sx={{ color: INK.MUTED, flexShrink: 0, transform: (theme) => (theme.direction === "rtl" && !isExpanded ? "scaleX(-1)" : "none") }}
				/>
			)}
			<Box
				component="span"
				title={label}
				sx={{ overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", minWidth: 0, color: INK.SECONDARY, fontWeight: isEmphasized ? 600 : 400 }}
			>
				{label}
			</Box>
		</Box>
	);
};
